import BuildingsHome6Line from './buildings-home-6-line.component.js'

export * from './buildings-home-6-line.component.js'
export default BuildingsHome6Line

BuildingsHome6Line.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-home-6-line': BuildingsHome6Line
  }
}
